module.exports = __webpack_public_path__ + "media/images/Time-94a4cbdc.png";